// extracted by mini-css-extract-plugin
export default {"container":"Ppj7gB","square":"TWzcdD","wide":"DozZF6"};